module.exports = ".search-dropdown {\n  border-color: #ececec;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 2px;\n  width: 100%;\n  padding: 6px;\n  cursor: pointer;\n  z-index: 9999;\n  position: absolute;\n  margin-top: -6px;\n  background-color: #ffffff; }\n\n.search-result-item {\n  padding: 5px;\n  color: #000000;\n  margin-bottom: 4px;\n  clear: both;\n  display: inline-block;\n  width: 100%;\n  font-size: 14px; }\n\n.search-selected {\n  background-color: lightblue;\n  color: #ffffff; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/search/search.component.scss
// module id = ./src/app/modules/search/search.component.scss
// module chunks = main